module.exports = __webpack_public_path__ + "static/media/spange-red.93229ffa.jpg";